export default __webpack_public_path__ + "static/media/migration.5462ced7.jpg";